module.exports = __webpack_public_path__ + "img/featured-international-business-times.62f414a7.png";